import 'owl.carousel2/dist/assets/owl.carousel.css';
import $ from 'jquery';
import 'owl.carousel2/dist/owl.carousel.min';


$(function () {
    const $slider = $('.slider-owl-carousel');
    if ($slider.length) {
        $slider.owlCarousel({
            loop: true,
            margin: 0,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: true,
                    loop: true,
                },
            },
        });
    }
});



// WEBPACK FOOTER //
// ./js/home/slider.js